module.exports = __webpack_public_path__ + "img/iconButtonBlock.8a568bf0.svg";